import styled from "@emotion/styled";
import { BannerAction } from "../components/BannerAction";
export const BannerDismissButtonStyled = styled(BannerAction)`
    width: 32px;
    padding: 0;
`;
//# sourceMappingURL=BannerDismissButtonStyled.js.map